import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import IntlMessages from 'util/IntlMessages';
import { ModalHeader } from 'reactstrap';
import {createNewAvtal,getKundKontakter,onSetZeroKundSearch,getDefaultTermsofPayment, getKundUtoningListByType } from 'actions';
import MuiAlert from '@material-ui/lab/Alert';
import KundInput from "./KundInput";
import KontaktPerson from "./KontaktPerson";
import { isUndefined,isEmpty, isNull } from 'lodash'
import Övrigt from "./Övrigt";
import Billing from "./Billing";
import moment from 'moment';
import {Grid, Paper,Button,Typography,Snackbar,Tooltip, TextField} from "@material-ui/core";
import Stepper from "./stepper";
import TaggarComponent from 'components/TaggarComponent'


const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

function mapStateToProps({auth,Avtal,accountsData}) {
    const { authUser} = auth;
    const { isLoading,message,currentAvtal,AvtalTyp } = Avtal;
    const { KontakterList,KundSearch,Flags, UtokningKundList } = accountsData;
    return {
        isLoading,message,authUser,KontakterList,currentAvtal,KundSearch,Flags,
        AvtalTyp, UtokningKundList
    };
}
function mapDispatchToProps(dispatch) {
    return {
        createNewAvtal: (userid,AFid,Navtal) => dispatch(createNewAvtal(userid,AFid,Navtal)),
        getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
        getDefaultTermsofPayment: (AFid) => dispatch(getDefaultTermsofPayment(AFid)),
        getKundUtoningListByType: (Afid,userid, Orgnr, Type) => dispatch(getKundUtoningListByType(Afid,userid, Orgnr, Type)),
        onSetZeroKundSearch: () => dispatch(onSetZeroKundSearch()),
        dispatch
    };
}
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

class PopUpSA extends Component {
    
    state = {
        activeStep: 0,
        message: "",
        showMessage: false,
        skipped: new Set(),
        KontakterList:[],
        newAvtal:{
            Kund:{},
            Kontakt:{},
            taggar: [],
            KundStatus:1,
            Avtal:{
                avtaltyp:0,
                Leverantor:"",
                Slutdatum:moment().format("YYYY-MM-DD"),
                Omforhandle:moment().format("YYYY-MM-DD"),
                StartDate:moment().format("YYYY-MM-DD"),
                Varde:"",
                Rubrik:"",
                Laperut:0,
                isBilling:0,
                startDate:moment(new Date()).format("YYYY-MM-DD"),
                lopande:0,
                PeriodStart:moment(new Date()).startOf("month").format("YYYY-MM-DD"),
                Periodslut:moment(new Date()).endOf("month").format("YYYY-MM-DD"),
                BillingIntervall:1,
                BillingLength:1,
                termofPayment:15 ,
                PrisListId:0,
                Ansvarig:this.props.authUser.user_id
            },
            PrisListId:0,
            fetchKalkUtokningId: 0
        }
    };
    handleRequestClose = () => {
        this.setState({
          showMessage: false,
          message: ''
        });
      };
      SetAvtalKParameters = (kontakt)=>{
        this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                kontakt:kontakt
            }
        })
    }
    componentDidMount=()=>{
        const Kontoid = this.props.authUser.user_Afid;
        this.props.getDefaultTermsofPayment(Kontoid)
    }
    SetAvtalParameters = (Avtal)=>{
       this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                Avtal:Avtal
            }
        })
    }
    SetPrisListaParameters = (PrisListId)=>{
       this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                PrisListId:PrisListId
            }
        })
    }
    setTaggar = (taggar) => {
      this.setState({
        newAvtal:{
            ...this.state.newAvtal,
            taggar:taggar
        }
      })
    }
    SetAvtalKundParameters = (Kund)=>{
        console.log(Kund,"props.TypAvaffa")
        this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                Kund:Kund,
                PrisListId:Kund.DefaultPricelistId
            }
        })
        if(!isUndefined(Kund.Orgnr) && Kund.Source===1){
            const userid = this.props.authUser.user_id;
            const Kontoid = this.props.authUser.user_Afid;
            this.props.getKundKontakter(userid,Kontoid,Kund.Orgnr)
        }
        if(!isUndefined(Kund.Orgnr)) {
            const userid = this.props.authUser.user_id;
            const Kontoid = this.props.authUser.user_Afid;
            this.props.getKundUtoningListByType(Kontoid,userid, Kund.Orgnr, 2)
        }
    }
    componentDidUpdate=()=>{
        if(this.state.KontakterList !== this.props.KontakterList){
            this.setState({
                KontakterList:this.props.KontakterList
            })
        }
        if(!isEmpty(this.props.currentAvtal)){
            // const id = this.props.currentAvtal.Avtal.id
        }
    }
    checkIfDisabled=()=>{
        if(
            isEmpty(this.state.newAvtal.Kund) || 
            isUndefined(this.state.newAvtal.kontakt) || 
            parseInt(this.state.newAvtal.Avtal.avtaltyp)===0 
        )
        {
            return true
        }else{
            return false
        }
    }
    saveNewAvtal=()=>{
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        const newAvtal =this.state.newAvtal;
        this.props.createNewAvtal(userid,Kontoid,newAvtal)  
        this.handleClose()
    }
    handleClose=()=>{
        this.props.onSetZeroKundSearch()
        this.setState({
            newAvtal:{
                Kund:{},
                Kontakt:{},
                taggar: [],
                Avtal:{
                    avtaltyp:0,
                    Leverantor:"",
                    Slutdatum:moment().format("YYYY-MM-DD"),
                    Omforhandle:moment().format("YYYY-MM-DD"),
                    StartDate:moment().format("YYYY-MM-DD"),
                    Varde:"",
                    Rubrik:"",
                    Laperut:0,
                    isBilling:0,
                    startDate:moment(new Date()).format("YYYY-MM-DD"),
                    lopande:0,
                    PeriodStart:moment(new Date()).startOf("month").format("YYYY-MM-DD"),
                    Periodslut:moment(new Date()).endOf("month").format("YYYY-MM-DD"),
                    BillingIntervall:1,
                    BillingLength:1,
                    termofPayment:15,
                    PrisListId:0,
                    Ansvarig:this.props.authUser.user_id
                },
                fetchKalkUtokningId: 0,
                PrisListId:0
            }
        })
        this.props.handleClose()
    }
    updateNAvtalKundStatus=(KundStatus)=>{
        this.setState({
            newAvtal:{
                ...this.state.newAvtal,
                KundStatus:KundStatus
            }
        })
    }
    render() {
        const { fullScreen } = this.props;
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title" 
            
            fullScreen={fullScreen}
            open={this.props.open} fullWidth={true}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        maxWidth={"md"}>
        <ModalHeader className="modal-box-header bg-primary text-white">
        {
                        parseInt(this.state.newAvtal.Avtal.isBilling) === 0?
                        <IntlMessages id="Skapa Avtal" />
                        :
                        "Skapa Avtalsfaktura"
                    } 
            {/* <IntlMessages id="Skapa Avtal" /> */}
            <IconButton className="text-white"
                onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers>
          {/*  <Stepper handleClose={this.props.handleClose}/>*/}
          <KundInput
          Kund={this.state.newAvtal.Kund} 
          updateNAvtalKundStatus={this.updateNAvtalKundStatus}
          KundSearch={this.props.KundSearch}               
          SetAvtalKundParameters={this.SetAvtalKundParameters}                
          />
           {/*Konttakt*/}
           {
              isEmpty(this.state.newAvtal.Kund.Orgnr)?"": 
              <Grid container>
                    <Grid item md={12} className="py-1 ">
                    <Paper variant="outlined" className={"p-1 m-0"}>
                   Kontakt
                   <KontaktPerson 
                    KundOrgnr={this.state.newAvtal.Kund.Orgnr}
                    kontakt={this.state.newAvtal.kontakt}
                    Kontakter={isEmpty(this.state.KontakterList)?[]:this.state.KontakterList}
                    isLoading={isEmpty(this.state.KontakterList)?true:false}
                    SetAvtalParameters={this.SetAvtalKParameters}
                    />
                   </Paper>
                    </Grid> 
                    <Grid item md={12} className="py-1 ">
                    <Paper variant="outlined" className={"p-1 m-0"}>
                    <Övrigt 
                    AvtalTyplist={this.props.AvtalTyp}
                    Flags={this.props.Flags}
                    newAvtal={this.state.newAvtal}
                    SetAvtalParameters={this.SetAvtalParameters}
                    SetPrisListaParameters={this.SetPrisListaParameters}
                    />
                    </Paper>
                    </Grid>
                    
                    {
                        parseInt(this.props.Flags.Fortnox)=== 1?
                        <Grid item md={12} className="py-1 ">
                        <Paper variant="outlined" className={"p-1 m-0"}>
                        <Billing 
                        newAvtal={this.state.newAvtal}
                        SetAvtalParameters={this.SetAvtalParameters}
                        />
                        </Paper>
                        </Grid>
                        :""
                    }
                    {
                        !isEmpty(this.props.UtokningKundList) &&
                        <Grid item md={12} className='mt-1'>
                            <TextField
                                select
                                label={<IntlMessages id="Label.get.Calculation.from"/>}
                                variant="outlined"
                                size="small"
                                name="id"
                                value={this.state.newAvtal.fetchKalkUtokningId}
                                fullWidth
                                onChange={(e)=>this.setState(state => ({...state,newAvtal:{...this.state.newAvtal, fetchKalkUtokningId: parseInt(e.target.value)}}))}
                                SelectProps={{native: true,}}
                                InputLabelProps={{shrink: true,}}
                            >
                                <option value={0}><em><IntlMessages id={"None2"} /></em></option>
                                {this.props.UtokningKundList.map(u => 
                                <option key={u.id} value={u.id}>
                                    {`${u.ObjektName} ${isNull(u.FaltName) ? `#${u.id}` : u.FaltName}`}
                                </option>)}
                            </TextField>
                        </Grid>
                    }
                    <Grid item md={12}>
                      <div className='mt-2'>
                      <TaggarComponent
                        Source={3}
                        onChange={this.setTaggar}
                      /></div>
                    </Grid>
              </Grid> 
           }
        </DialogContent>
        <DialogActions>
        <Grid
  container
  direction="row"
  justify="space-between"
  alignItems="center"
>
                <div>
                <Button
                onClick={this.handleClose}
                className="jr-btn"
                variant="outlined"
                color="default"
                >
                    <IntlMessages id="Cancel"/>
                </Button>
                </div>
                <div>
                <Tooltip title="Glöm inte att fylla i Kund, kontakt, och Type" placement="top">
                <Button
                color="primary"
                size={"small"}
                disabled={this.checkIfDisabled()}
                className="jr-btn"
                variant="contained"
                onClick={this.saveNewAvtal}
                >
                    <IntlMessages id="Create"/>
                </Button> 
                </Tooltip>
                </div>
            </Grid>
        </DialogActions>
        <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={this.state.showMessage}
        autoHideDuration={3000}
        onClose={this.handleRequestClose}
        ContentProps={{
            "aria-describedby": "message-id"
        }}>
            <Alert onClose={this.handleRequestClose} 
            severity={this.state.message === "Error"?"error":"success"}
            ><span id="message-id">{this.state.message}</span></Alert>
        </Snackbar>
    </Dialog> 
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)((withMediaQuery([
    ['fullScreen', theme => theme.breakpoints.down('xs'), {
      defaultMatches: true
    }]
  ]))(PopUpSA));


